import { createSelector } from '@ngrx/store';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';

export const canShowPriceForIngredient = (ingredient: APICommon.ProductIngredientExtended, swap?: APICommon.IngredientProductSwapExtended) =>
    createSelector(getWizzardSimpleItem, (simpleItem: OLO.State.Wizzard.WizzardSimpleItem) => {
        if (!simpleItem) return false;

        if (swap) {
            const isSwapSelected = simpleItem.IngredientsChanges?._SelectedIngredientPLUs?.includes(swap.NewPLU);

            return isSwapSelected && !!swap.ExtraPrice;
        }

        const isIngredientSelected = simpleItem.IngredientsChanges?._SelectedIngredientPLUs?.includes(ingredient.IngredientPLU);

        if (!isIngredientSelected) return false;

        if (ingredient.IngredientMode === OLO.Enums.INGREDIENT_MODE.OPTIONAL) {
            const addedIngredient = simpleItem.IngredientsChanges?.IngredientsAdded?.find((ing) => ing.IngredientPLU === ingredient.IngredientPLU);

            return !!addedIngredient?.ExtraPrice;
        }

        const modifiedIngredient = simpleItem.IngredientsChanges?.IngredientsModified?.find((ing) => ing.IngredientPLU === ingredient.IngredientPLU);

        return !!modifiedIngredient?.ExtraPrice;
    });
